module.exports = __webpack_public_path__ + "static/media/logo.947ef975.svg";